import { defineComponent, ref, computed, createBlock, openBlock, unref, withCtx, createElementVNode, normalizeClass, createVNode, renderSlot, Teleport, createElementBlock, createCommentVNode, normalizeStyle, Fragment, renderList, toDisplayString } from "vue";
import { useFloating, offset, flip, shift, autoUpdate } from "@floating-ui/vue";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue";
const _hoisted_1 = { class: "option-label" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowListbox",
  props: {
    options: {},
    modelValue: {},
    static: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const dropdownRef = ref(null);
    const buttonWrapper = ref(null);
    const triggerRef = computed(
      () => {
        var _a, _b;
        return ((_b = (_a = buttonWrapper.value) == null ? void 0 : _a.children) == null ? void 0 : _b[0]) || buttonWrapper.value;
      }
    );
    const { floatingStyles } = useFloating(triggerRef, dropdownRef, {
      placement: "bottom-start",
      whileElementsMounted: autoUpdate,
      middleware: [offset(5), flip(), shift()]
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Listbox), {
        as: "div",
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _ctx.$emit("update:modelValue", v))
      }, {
        default: withCtx(({ open }) => [
          createElementVNode("div", {
            ref_key: "buttonWrapper",
            ref: buttonWrapper,
            class: normalizeClass({
              "button-wrapper": !!_ctx.$slots.default
            })
          }, [
            createVNode(unref(ListboxButton), { as: "template" }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {}, void 0, true)
              ]),
              _: 3
            })
          ], 2),
          (openBlock(), createBlock(Teleport, {
            disabled: _ctx.static,
            to: "#app"
          }, [
            open ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "dropdownRef",
              ref: dropdownRef,
              class: "floating",
              style: normalizeStyle(unref(floatingStyles))
            }, [
              createVNode(unref(ListboxOptions), {
                class: "dropdown",
                static: ""
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option) => {
                    return openBlock(), createBlock(unref(ListboxOption), {
                      key: option.id,
                      as: "template",
                      disabled: option.disabled,
                      value: option
                    }, {
                      default: withCtx(({ active, selected }) => [
                        createElementVNode("li", {
                          class: normalizeClass(["option", { active, selected }])
                        }, [
                          createElementVNode("span", _hoisted_1, toDisplayString(option.label), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "value"]);
                  }), 128))
                ]),
                _: 1
              })
            ], 4)) : createCommentVNode("", true)
          ], 8, ["disabled"]))
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowListbox.vue2.js.map
